import type { User } from "../types/models";

export function getAuthRedirect(user: User | null, loading: boolean, currentPath: string): string | null {
  if (loading) {
    return null;
  }
  if (!user) {
    return "/auth";
  }
  if (!isOnboardingComplete(user) && currentPath !== "/onboarding") {
    return "/onboarding";
  }
  if (isOnboardingComplete(user) && currentPath === "/onboarding") {
    return "/today";
  }
  if (currentPath === "/" || currentPath === "") {
    return "/today";
  }
  return null;
}

export function isOnboardingComplete(user: User): boolean {
  return Boolean(user.onboarding_completed_at && user.height_cm && user.date_of_birth && user.sex_for_hydration_formula);
}
